<template>
  <div class="process-wrapper" :class="{ addGray: addGray }">
    <div class="process-child" ref="processChild">
      <p class="process-animate"></p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    addGray: {
      //置灰
      type: Boolean,
      default: false,
    },
    progressWidth: {
      //进度条百分比
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
    };
  },
  watch: {
    progressWidth(newVal, oldVal) {
      console.log("-newVal:-", newVal);
      if (newVal || newVal == 0) {
        this.progressWidth = newVal;
        this.updateBoxWidth();
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      console.log(this.addGray, "addGray---");
      this.updateBoxWidth();
    });
  },
  methods: {
    updateBoxWidth() {
      console.log("-updateBoxWidth():-", this.progressWidth);
      this.$refs.processChild.style.width = this.progressWidth + "%"; //动态改变进度条
      //   this.$refs.processChild.style.width = 90 + "%"; // 测试效果
    },
  },
};
</script>

<style lang="scss" scoped>
.process-wrapper {
  width: 20vw;
  height: 2vh;
  //   margin: 5vh 0 5vh 0;
  border-radius: 2vw;
  background: #fff;
  border: 1px solid #01a408;
  &.addGray {
    background: #eaf3fd;
    border: 1px solid #eaf3fd;
  }
  .process-child {
    position: relative;
    height: 100%;
    // width: 100%;  //这个width就是动态变化。通过js改变
    border-radius: inherit;
    .process-animate {
      background: #01a408;
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      border-radius: inherit;
      animation: process 1s linear forwards;
      //   &.addGray {
      // background: #999 !important;
      // border: 0.01rem solid #999;
      //   }
    }
  }
}

@keyframes process {
  0% {
    left: 0;
    right: 100%;
  }
  20% {
    right: 80%;
  }
  40% {
    right: 60%;
  }
  60% {
    right: 40%;
  }
  80% {
    right: 20%;
  }
  100% {
    right: 0;
  }
}
</style>
